<template>
  <div>
    <wc-data-box
      title='Driveway Rating'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='showEdit'
      @edit='changeRating'
      :loading='isLoading'
    >
      <v-card-text class='text-center'>
        <h1 class='display-1 font-weight-light info--text'>{{ ratingDisplay.rating | dec }}</h1>
        <h2 class='mt-2'>{{ ratingDisplay.description }}</h2>
      </v-card-text>
      <wc-ratings :selected_obj='project.project_detail.driveway_rating_obj'></wc-ratings>
    </wc-data-box>
    
    <wc-dialog
      :showDialog='showDialog'
      title='Change Rating'
      :icon='icon'
      :iconColor='iconColor'
      width='300'
      @cancel='showDialog = false'
      @save='updateRating'
    >
      <v-select
        v-model='projectCopy.project_detail.driveway_rating'
        label='Select a rating'
        :items='ratings'
        item-text='description'
        item-value='id'
      >
        <template v-slot:item='{ item }'>
          {{ "$" + item.base_price + " - " + item.description }}
        </template>
      </v-select>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import settingsAPI from '@/modules/settings/api/settings'

export default {
  name: 'driveway-rating',
  props: {
    project: {
      required: true
    },
    showEdit: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    isLoading: true,
    showDialog: false,
    projectCopy: {
      project_detail: {}
    },
    ratings: [],
    icon: 'mdi-home-outline',
    iconColor: 'brown'
  }),
  computed: {
    ratingDisplay () {
      if (this.ratings.length > 0 && this.project) {
        if (this.project.project_detail.driveway_rating) {
          return this.ratings.find(r => r.id === this.project.project_detail.driveway_rating)
        }
      }
      return { rating: 0, description: '---' }
    }
  },
  mounted () {
    this.getRatings()
  },
  methods: {
    changeRating () {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    async getRatings () {
      this.isLoading = true
      let tmp = await settingsAPI.getDrivewayRatings()
      this.ratings = _.orderBy(tmp, 'rating')
      this.isLoading = false
    },
    async updateRating () {
      this.$emit('update', this.projectCopy)
      this.showDialog = false
    }
  }
}
</script>
